import {apiRequest} from "@/services/api/apiClient.js";
import axios from 'axios';

export async function fetchPersonByCpf(cpf) {
    const configResponse = await apiRequest({
        client: API_CHECKIN,
        method: "get",
        url: '/configs?name=Totem'
    });

    const config = configResponse?.data?.[0];

    const res = await axios.get(`/integrations/people/${cpf}`, {
        headers: {
            config: JSON.stringify(config)
        }
    });

    return res.data;
}
